import { PerformanceReviewTemplateEditPageStep } from "@/pages/talent/performance-reviews/templates/edit/performance-review-template-edit.tsx";
import { ApiFormTemplate } from "@/types/forms/form-template.types.ts";
import { DotSeparator, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

const performanceReviewTemplateSteps = [
  PerformanceReviewTemplateEditPageStep.details,
  PerformanceReviewTemplateEditPageStep.questions,
];

interface PerformanceReviewTemplateTitleSlotProps {
  step: PerformanceReviewTemplateEditPageStep;
  template?: ApiFormTemplate;
}

export const PerformanceReviewTemplateTitleSlot = ({
  step,
  template,
}: PerformanceReviewTemplateTitleSlotProps) => {
  const { t } = useTranslation();
  const stepIndex = performanceReviewTemplateSteps.indexOf(step);

  return (
    <DotSeparator className={"inline-flex"}>
      <Text className={"font-semibold"}>{t("performance_review:performance_review_template")}</Text>
      {stepIndex > 0 && template && (
        <Stack gap={"sm"} direction={"horizontal"} items={"center"}>
          <Text className={"font-semibold"}>{template.title}</Text>
        </Stack>
      )}
      <Text>
        {t("core:step_of", {
          currentStep: stepIndex + 1,
          countSteps: performanceReviewTemplateSteps.length,
        })}
      </Text>
    </DotSeparator>
  );
};
